import { render, staticRenderFns } from "./MPrice.vue?vue&type=template&id=6c624baa&"
import script from "./MPrice.vue?vue&type=script&lang=ts&"
export * from "./MPrice.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports